import React, { MouseEvent, useContext } from 'react';
import { Channel } from 'talkplus-sdk/dist/model/types';
import ChatListItem from '@components/chat/common/chatListItem';
import { ListLoadingMotion } from '@components/chat/common/loadingList';
import EmptyMyChat from '@components/chat/chatList/emptyMyChat';
import { ChatContext, ChatContextType } from '@components/chat/ChatContext';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface MyChatProps {
  handleChannelClick: (channel: Channel) => void;
  handleMenuPosition: (event: MouseEvent<HTMLElement>) => void;
}

const MyChat = ({ handleChannelClick, handleMenuPosition }: MyChatProps) => {
  const { myChannelsData, selectedChannel, setSelectedChannel, getIsNotification, updateNotification } =
    useContext<ChatContextType>(ChatContext);
  const myChannelsCount = myChannelsData ? myChannelsData?.channels?.length || 0 : 0;

  const handleClickMenu = async (event: MouseEvent<HTMLElement>, channel: Channel | null) => {
    if (selectedChannel === channel) return setSelectedChannel(null);
    if (!channel) return;
    updateNotification(channel.id);
    handleMenuPosition(event);
    setSelectedChannel(channel);
  };

  const listEls = myChannelsData?.channels?.map((channel, index) => {
    const isNotifying = getIsNotification(channel?.id);
    return (
      <ChatListItem
        key={index}
        channel={channel}
        messageVisible={true}
        isNotifying={isNotifying}
        isMenu={true}
        onClick={() => handleChannelClick(channel)}
        onClickMenu={(event) => handleClickMenu(event, channel)}
      />
    );
  });

  const getEl = () => {
    if (!myChannelsData) return <ListLoadingMotion listCount={3} />;
    if (myChannelsCount <= 0) return <EmptyMyChat />;
    return <ul className={cx('listWrap')}>{listEls}</ul>;
  };

  return (
    <div className={cx('chatArea')}>
      <div className={cx('titleArea')}>
        <span className={cx('title')}>내 채팅</span>
        <span className={cx('number')}>{myChannelsCount}</span>
      </div>
      {getEl()}
    </div>
  );
};

export default MyChat;
